export const POLICY_MSG = "La password deve contenere almeno 12 caratteri, una maiuscola, una minuscola, un numero e un simbolo";
export const EMAIL_MSG = "La password non deve contenere il tuo indirizzo email";

export const passwordRules = (pw, email = "") => {
    const local = (email || "").split("@")[0].toLowerCase();
    return [
        { key: "len", label: "Almeno 12 caratteri", ok: pw.length >= 12 },
        { key: "upper", label: "Una lettera maiuscola", ok: /[A-Z]/.test(pw) },
        { key: "lower", label: "Una lettera minuscola", ok: /[a-z]/.test(pw) },
        { key: "digit", label: "Un numero", ok: /\d/.test(pw) },
        { key: "symbol", label: "Un simbolo (es. ! ? - _ @)", ok: /[^A-Za-z0-9]/.test(pw) },
        { key: "email", label: "Non contiene il tuo indirizzo email", ok: pw.length > 0 && !(local.length >= 4 && pw.toLowerCase().includes(local)) },
    ];
};

export const passwordLevel = (pw, email) => {
    const met = passwordRules(pw, email).filter((r) => r.ok).length;
    if (met === 6 && pw.length >= 14) return "Forte";
    if (met >= 5) return "Media";
    return "Debole";
};

// Same order as the server (length → common → email → classes): the client only blocks on length,
// the server returns the exact common / email / rules message as a field error.
export const policyError = (pw) => (pw.length < 12 ? POLICY_MSG : null);

const SETS = ["ABCDEFGHJKLMNPQRSTUVWXYZ", "abcdefghijkmnpqrstuvwxyz", "23456789", "!?@#%&*-_+="];

export const generatePassword = (len = 16) => {
    const all = SETS.join("");
    const rand = (n) => { const a = new Uint32Array(1); window.crypto.getRandomValues(a); return a[0] % n; };
    const chars = SETS.map((s) => s[rand(s.length)]);
    while (chars.length < len) chars.push(all[rand(all.length)]);
    for (let i = chars.length - 1; i > 0; i -= 1) { const j = rand(i + 1); [chars[i], chars[j]] = [chars[j], chars[i]]; }
    return chars.join("");
};
